/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The kind of personally identifiable information a value (or form element's answers) contains.
 * Drives which fake replacement is generated during anonymization.
 */
export enum PiiKind {
    NOT_PII = 'NotPii',
    PERSON_NAME = 'PersonName',
    FIRST_NAME = 'FirstName',
    LAST_NAME = 'LastName',
    EMAIL = 'Email',
    PHONE = 'Phone',
    SIN = 'Sin',
    ADDRESS = 'Address',
    POSTAL_CODE = 'PostalCode',
    DOB = 'Dob',
    FREE_TEXT = 'FreeText',
    FILE_NAME = 'FileName',
}
